import { createFileRoute } from '@tanstack/react-router'
import ModuleTests from '@/features/test'

export const Route = createFileRoute('/_authenticated/test/')({
  component: ModuleTests,
})
